import { FeatureFlag } from '../FeatureFlag';

export const showInviteCodesForProfessionalTraders = new FeatureFlag({
    key: 'show-invite-codes-for-professional-traders',
    createdOn: '2026-05-22',
    defaultValue: false,
});
